module.exports = __webpack_public_path__ + "media/images/email/mail-f428d3e038cf18dcd3838aa257735d66.svg";